import React from 'react';
import { useIntl } from 'react-intl';
import { useAuth0 } from '@auth0/auth0-react';

import Layout from 'components/Layout';
import Title from 'components/ui/Title';
import SidebarBox from 'components/ui/SidebarBox';

import { Wrapper } from './FanDomePage.styles';


const FanDomePage = () => {
  const intl = useIntl();
  const { isAuthenticated } = useAuth0();

  return (
    <Layout
      sidebar={
        <SidebarBox>
          <Title>
            {intl.formatMessage({ id: 'sidebar.polls' })}
          </Title>
          <p>[WORK IN PROGRESS]</p>
        </SidebarBox>
      }
    >
      <Wrapper>
        <Title size="big" color="secondary">
          {intl.formatMessage({ id: 'fanDome.title' })}
        </Title>
        {
          isAuthenticated ? (
            <React.Fragment>
              <p>This section is only for logged in users!</p>
            </React.Fragment>
          ) : null
        }
        <p>{intl.formatMessage({ id: 'fanDome.description' })}</p>
      </Wrapper>
    </Layout>
  );
};

export default FanDomePage;
